<template>
  <div class="card">
    <!-- @slot Conteudo -->
    <slot></slot>
  </div>
</template>
<script>
/**
 * Um card
 */
export default {
  name: "HcCard"
};
</script>
